import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=bb5e4dda&scoped=true"
import script from "./BannerForm.vue?vue&type=script&lang=js"
export * from "./BannerForm.vue?vue&type=script&lang=js"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=bb5e4dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5e4dda",
  null
  
)

export default component.exports